import { useContext, useState, useEffect } from "react";
import { postAuthLogin, getUserInfo } from "../../services/UserServices";
import { LoginFormContext } from "./LoginContext";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../AuthContext"; // Asegúrate de importar AuthContext

export const LoginFormState = ({ children }) => {
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [empresaData, setEmpresaData] = useState({})
    const [userData, setUserData] = useState({})
    const { login } = useContext(AuthContext);

    const postLoginData = async (body) => {
        const res = await postAuthLogin(body);
        if (res?.data?.token) {
            localStorage.setItem('paneltoken', res.data.token);
            login()
        }
        else {
            setError(res);
        }
        return res;
    };

    return (
        <LoginFormContext.Provider value={{
            postLoginData,
            empresaData,
            userData,
            error
        }}>
            {children}
        </LoginFormContext.Provider>
    );
};